import { TIPOS_DOCUMENTO } from './gastos'

// Permisos de Gastos: espejo de private.usuario_puede_modificar_gasto_f2.
// La autoridad es la RLS de Supabase; esto solo oculta/deshabilita lo que
// el backend rechazaría y traduce sus errores.

export const TIPOS_FACTURA = ['factura', 'factura_exenta']

export function esCategoriaFruta(categoria) {
  return (
    String(categoria?.nombre ?? '')
      .trim()
      .toLowerCase() === 'compras de fruta'
  )
}

export function esTipoFactura(tipoDocumento) {
  return TIPOS_FACTURA.includes(tipoDocumento)
}

// Administrador: todo. Aprobador: todo salvo "Compras de Fruta".
// Usuario: sin facturas ni "Compras de Fruta". Consulta y POS Venta: nada.
export function puedeModificarGasto(rol, { tipoDocumento, categoria } = {}) {
  const fruta = esCategoriaFruta(categoria)

  if (rol === 'administrador') return true
  if (rol === 'aprobador') return !fruta
  if (rol === 'usuario') return !esTipoFactura(tipoDocumento) && !fruta

  return false
}

export function puedeCrearGastos(rol) {
  return ['administrador', 'aprobador', 'usuario'].includes(rol)
}

// Tipos de documento que el rol puede elegir en el formulario.
export function tiposDocumentoPermitidos(rol) {
  return Object.entries(TIPOS_DOCUMENTO).filter(
    ([valor]) => rol !== 'usuario' || !esTipoFactura(valor)
  )
}

// Solo el Administrador puede usar "Compras de Fruta" en gastos manuales.
export function categoriasPermitidas(rol, categorias) {
  if (rol === 'administrador') return categorias

  return categorias.filter((categoria) => !esCategoriaFruta(categoria))
}

export function tipoDocumentoInicial(rol) {
  return rol === 'usuario' ? 'boleta' : 'factura'
}

// Un gasto lo edita/elimina su creador o el administrador, siempre que
// además el rol pueda manejar su tipo de documento y categoría.
export function puedeGestionarGasto(rol, gasto, usuarioId) {
  if (!gasto) return false

  const propio = Boolean(usuarioId) && gasto.creado_por === usuarioId

  if (!propio && rol !== 'administrador') return false

  return puedeModificarGasto(rol, {
    tipoDocumento: gasto.tipo_documento,
    categoria: gasto.categoria,
  })
}

// Un gasto generado por una factura de Abastecimiento nunca se anula
// directamente (el backend lo bloquea).
export function puedeEliminarGasto(rol, gasto, usuarioId, vinculado) {
  return !vinculado && puedeGestionarGasto(rol, gasto, usuarioId)
}

// Campos que el backend sí admite cambiar en un gasto vinculado.
export const CAMPOS_PAGO_GASTO = [
  'descripcion',
  'estado_pago',
  'medio_pago',
  'fecha_pago',
  'observaciones',
]

export function soloCamposPago(datos) {
  return Object.fromEntries(
    CAMPOS_PAGO_GASTO.map((campo) => [campo, datos[campo]])
  )
}

export function mensajeErrorGasto(error) {
  const mensaje = error?.message || ''

  if (mensaje.includes('ux_gastos_factura_proveedor_documento_f2')) {
    return 'Ya existe una factura de este proveedor con ese número. Revisa el listado de Gastos para evitar duplicados.'
  }

  if (
    error?.code === '42501' ||
    /row-level security/i.test(mensaje) ||
    /permission denied/i.test(mensaje)
  ) {
    return 'Tu perfil no tiene permisos para esta operación. Las facturas manuales y la categoría «Compras de Fruta» requieren un rol autorizado.'
  }

  return mensaje || 'No fue posible completar la operación.'
}
